export const getFullName = (firstname, lastName) => {
  let fullName = "";
  if (firstname) fullName += firstname + " ";
  if (lastName) fullName += lastName;
  return fullName;
};
